import QuickBooksDialogs from "../dialogs/quickbooks/quickbooksDialogs";

export const quickbooksConfig = {
  title: "QuickBooks Management",
  columns: [
    { field: "accountName", headerName: "Account Name", type: "sort" },
    {
      field: "primaryContact",
      headerName: "Primary Contact",
      type: "multiSelectSort",
    },
    { field: "emailAddress", headerName: "Email Address", type: "sort" },
    { field: "quickbooksStatus", headerName: "QuickBooks Status", type: "status" },
    { field: "syncStatus", headerName: "Sync Status", type: "status" },
    { field: "notes", headerName: "Notes", type: "notes" },
    { field: "actions", headerName: "Actions", type: "actions" },
  ],
  dialogs: QuickBooksDialogs,
  createButtonText: null,
  emptyMessage: "No QuickBooks accounts found",
};
